/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';
import Wait from '@react/react-spectrum/Wait';

import Copy from '@nebula/luna/dist/core/copy';
import SessionForm from '../session.form';

import styles from './styles/form.content.styl';
import spinnerStyles from '../styles/centered-spinner.styl';

const MSG = defineMessages({
  description: {
    id: 'gemini.session.create.description',
    defaultMessage: 'Name this session and provide a link to launch the app on a device.'
  }
});

const SessionCreateFormContent = ({
  saving = false,
  izzy,
  ...props
}) => (
  <React.Fragment>
    { saving
      ? (
        <div className={styles['spinner-container']}>
          <Wait
            className={spinnerStyles['centered-spinner-large']}
            size="L"
          />
        </div>
      )
      : (
        <div
          data-omega-element="create session form"
          data-omega-widget="create session form"
          data-omega-widget-type="modal"
        >
          <Copy className={styles.description}>{izzy(MSG.description)}</Copy>
          <SessionForm
            className={styles.form}
            izzy={izzy}
            {...props}
          />
        </div>
      )
    }
  </React.Fragment>
);

SessionCreateFormContent.displayName = 'SessionCreateFormContent';
export default SessionCreateFormContent;
